var _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoriesDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -4.44444,
    y: -4.44444,
    width: 48.8889,
    height: 48.8889
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.22px)",
      clipPath: "url(#bgblur_0_5445_229169_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 4.44444,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "black",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1822 22.4746L19.9998 28.657L13.8174 22.4746",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.3418V28.4835",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_5445_229169_clip_path",
    transform: "translate(4.44444 4.44444)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoriesDownload);
export default __webpack_public_path__ + "static/media/stories-download.853233b7ec4d23139eb67646754187a7.svg";
export { ForwardRef as ReactComponent };